<template>
  <div class="bg-white p-4 shadow-sm h-max">
    <div class="w-full flex gap-4 items-center">
      <img :src="detail?.product?.thumbnail" class="w-[12.5rem] h-full rounded" alt="" />
      <div class="w-full">
        <div class="flex justify-between items-center mb-2">
          <p class="font-bold text-main-color text-xl">{{ detail?.product?.name }}</p>
          <button
            @click="deleteCartItem(0)"
            class="bg-[#EB5757] p-2 flex items-center justify-center rounded"
          >
            <IconTrash></IconTrash>
          </button>
        </div>
        <div v-if="detail?.product?.code" class="mb-2 flex gap-1">
          <p class="font-light text-[#333]">{{ $t('page.productCode') }}:</p>
          <span class="text-[#333] font-bold">{{ detail?.product?.code }}</span>
        </div>
        <div v-if="detail?.product?.country" class="mb-2 flex gap-1">
          <p class="font-light text-[#333]">{{ $t('page.manufacturedCountry') }}:</p>
          <span class="text-[#333] font-bold">{{ detail?.product?.country }}</span>
        </div>
        <div v-if="detail?.product?.brand" class="mb-2 flex gap-1">
          <p class="font-light text-[#333]">{{ $t('page.brand') }}:</p>
          <router-link
            v-if="detail?.product?.brand"
            :to="{
              name: 'brandProducts',
              params: { id: detail?.product?.brand_id },
              query: { brandName: detail?.product?.brand },
            }"
            ><p class="text-main-color font-bold">{{ detail?.product?.brand }}</p></router-link
          >
        </div>
        <div v-if="detail?.product?.description" class="mb-2 flex gap-1">
          <p class="font-light text-[#333]">{{ $t('page.info') }}:</p>
          <span class="text-[#333] font-bold">{{ detail?.product?.description }}</span>
        </div>
        <div v-if="detail?.size" class="mb-2 flex gap-1">
          <p class="font-light text-[#333]">{{ $t('page.size') }}:</p>
          <span class="text-[#333] font-bold">{{ detail?.size }}</span>
        </div>

        <div class="mb-2 flex gap-1 items-center justify-between">
          <div
            v-if="detail?.in_promotion"
            class="bg-red-500 text-white text-sm w-7 h-7 text-center font-semibold rounded-full p-1"
          >
            A
          </div>
          <div class="flex font-semibold items-center gap-2">
            {{ $t('page.onCredit') }} <IconChecked v-if="detail?.for_credit" />
            <IconUnchecked v-else />
          </div>
          <span
            v-if="detail?.is_new"
            class="m-1 absolute bg-green-500 text-white text-sm font-semibold rounded-lg p-1"
            >{{ $t('page.new') }}</span
          >
        </div>
        <div class="flex justify-between items-center">
          <p v-if="!detail?.discount_percent" class="text-[#409DBA] font-bold text-lg">
            {{ formatNumber(detail?.price) }} TMT
          </p>

          <p v-else class="text-[#409DBA] font-bold text-lg">
            {{ formatNumber(detail?.price) }} TMT
            <span class="line-through font-semibold text-base text-[#CB3131]">
              {{ formatNumber(detail?.original_price) }} TMT
            </span>
          </p>

          <div class="flex gap-1 font-bold">
            <button
              class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"
              @click="updateCartItem(detail?.quantity - 1)"
            >
              -
            </button>
            <span
              class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"
              >{{ detail?.quantity }}</span
            >
            <button
              class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"
              @click="updateCartItem(detail?.quantity + 1)"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTrash from '@icons/IconTrash.vue';
import IconChecked from '@icons/IconChecked.vue';
import IconUnchecked from '@icons/IconUnchecked.vue';
import { formatNumber } from '@/helpers';

export default {
  name: 'CartCard',
  components: {
    IconTrash,
    IconChecked,
    IconUnchecked,
  },
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    formatNumber,
    deleteCartItem(qty) {
      this.$store.deleteCartItem(this.detail?.id, qty).then(e => {
        this.loading = false;
      });
    },
    updateCartItem(qty) {
      this.loading = true;
      if (qty === 0) {
        this.deleteCartItem(this.detail?.id, qty);
        return;
      }
      this.$store.updateCartItem(this.detail?.id, qty).then(e => {
        this.loading = false;
      });
    },
  },
  computed: {},
  created() {},
};
</script>
